import script from "./WebsocketHandling.vue?vue&type=script&lang=js"
export * from "./WebsocketHandling.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__